"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAreasByRegionIds = void 0;
const getAreasByRegionIds = async (supabase, region_ids) => {
    const { data, error } = await supabase
        .from("area_listing")
        .select(`id, is_display_area, short_desc, name, name->en, type, region_id, region_name, country_id, longitude, latitude`)
        .neq("type", "Course")
        .neq("type", "Hotel")
        .in("region_id", region_ids)
        .eq("is_display_area", false);
    if (!error)
        return data;
    return error;
};
exports.getAreasByRegionIds = getAreasByRegionIds;
